import { Vector3 } from 'three';

import Representation2d from '../Representation2d';
import { ElementTypeEnum } from '../../../elementTypeMappings';
import LineloopsRepresentation2d from '../LineloopsRepresentation2d';
import ProductData from '../../productData/ProductData';
import DoorData from '../../productData/DoorData';

import { buildDoorRepresentation } from './DoorSymbolFactory';
import { cloneAndMove, move } from './SymbolDrawingUtils';
import { buildRectangle } from '../../../utils/shapeUtils';

const buildFillingRepresentation = (productData: ProductData, width: number, thickness: number  ): Representation2d => {

    switch (productData.productType) {
        case ElementTypeEnum.Door:
            if (productData instanceof DoorData)
                return buildDoorRepresentation(width, thickness, (productData as DoorData).operationType);
        case ElementTypeEnum.Window:
            return buildWindowRepresentation(width, thickness);
        default:
            throw new Error("Element type not supported");
    }
}

const buildWindowRepresentation = (width :number, thickness: number) => {

    const baseLoop = buildRectangle(0, width, 0, thickness);

    const centerLine = [ new Vector3(0, thickness/2, 0), new Vector3(width, thickness/2, 0) ];
    const offsetLine = cloneAndMove(centerLine, 0, -thickness/2/3);
    
    return new LineloopsRepresentation2d([baseLoop, centerLine, offsetLine], [baseLoop], null);
};

export { buildFillingRepresentation };